import React from 'react';
import { CSVLink } from 'react-csv';
import { CsvLinkBtn } from '../UI/CsvLinkBtn';


const UserDataExport = ({ userData }) => {

    const formatSensitiveDetails = (sensitiveDetail) => {
        if (!sensitiveDetail || sensitiveDetail.length === 0) return 'N/A';
        
        const detail = sensitiveDetail[0];
        const parts = [];

        if (detail.NINumber) parts.push(`NI Number: ${detail.NINumber}`);
        if (detail.taxCode) parts.push(`Tax Code: ${detail.taxCode}`);
        if (detail.passportNumber) parts.push(`Passport: ${detail.passportNumber}`);
        if (detail.passportExpiryDate) parts.push(`Passport Expiry: ${new Date(detail.passportExpiryDate).toLocaleDateString()}`);
        if (detail.issue_country?.issueCountry) parts.push(`Passport Issue Country: ${detail.issue_country.issueCountry}`);
        if (detail.licenseNumber) parts.push(`License: ${detail.licenseNumber}`);
        if (detail.licenseClass) parts.push(`License Class: ${detail.licenseClass}`);
        if (detail.licenseCountry?.issueCountry) parts.push(`License Country: ${detail.licenseCountry.issueCountry}`);
        if (detail.DLExpiryDate) parts.push(`License Expiry: ${new Date(detail.DLExpiryDate).toLocaleDateString()}`);
        if (detail.visaNumber) parts.push(`Visa: ${detail.visaNumber}`);
        if (detail.visaExpiryDate) parts.push(`Visa Expiry: ${new Date(detail.visaExpiryDate).toLocaleDateString()}`);

        return parts.join(' | ');
    };
    const processUserDataForCsv = (data) => {
        return data.map(user => ({
            'Employee ID': user.employeeId,
            'Title': user.salutations?.salutations || 'N/A',
            'First Name': user.firstName,
            'Last Name': user.lastName,
            'User Name': user.userName,
            'Email': user.email,
            'Phone': user.phone,
            'Gender': user.genders?.gender,
            'Blood Group': user.bloodGroup,
            'D.O.B': user.birthAnniversary,
            'Marital Status': user.maritalStatus ? 'Married' : 'Single',
            'Address': `${user.street}, ${user.city}, ${user.zipCode}, ${user.country}`,
            'Permanent Address': `${user.pStreet}, ${user.pCity}, ${user.pZipCode}, ${user.pCountry}`,

            'Join Date': user.joinDate,
            'Leave Date': user.leaveDate,
            'Payment Type': user.tbl_paymentType?.[0]?.payment_type?.paymentType || 'N/A',

            'Current Workplace': user.workPlaceHistory?.[0]?.workplace?.workplace || 'N/A',

            // Current Designation
            'Current Designation': user.designationHistory?.[0]?.designation?.name || 'N/A',

            // Current Salary
            'Current Salary': user.salaryHistory?.[0]?.salary || 'N/A',

            // Education Details
            'Education': user.educations?.map(edu =>
                `${edu.degree} - ${edu.institution} (${edu.fieldOfStudy})`
            ).join('; '),

            'Sensitive Details': formatSensitiveDetails(user.sensitive_detail),
            // Employment Status
            'Employment Status': user.employmentStatus?.name,

            // Department
            'Department': user.department?.name,

            // Role
            'Role': user.role?.name,

            // Shift
            'Shift': `${user.shift?.name} (${user.shift?.startTime?.slice(11, 16)} - ${user.shift?.endTime?.slice(11, 16)})`,

            // Leave Policy
            // 'Leave Policy': `${user.leavePolicy?.name} (Paid: ${user.leavePolicy?.paidLeaveCount}, Unpaid: ${user.leavePolicy?.unpaidLeaveCount})`,

            // Weekly Holiday
            'Weekly Off': `${user.weeklyHoliday?.startDay} to ${user.weeklyHoliday?.endDay}`,

            // Bank Details
            'Bank Details': user.bankDetails?.map(bank =>
                `${bank.bankName} - ${bank.accountNumber} - ${bank.shortCode}`
            ).join('; '),

        }));
    };

    const csvData = processUserDataForCsv(userData);

    return (
        <div>
            <CsvLinkBtn type="primary" className="flex items-center">
                <CSVLink
                    data={csvData}
                    filename={`employee_data_${new Date().toISOString().slice(0, 10)}.csv`}
                    className="text-white"
                >
                    Export to CSV
                </CSVLink>
            </CsvLinkBtn>
        </div>
    );
};

export default UserDataExport;